import { useState } from "react";

// Image that shows a tiny blurred preview (inlined from the API) until the
// full photo has decoded, then crossfades to it.
export const BlurImage = ({ lqip, className = "", wrapperClassName = "", style, ...imgProps }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <div className={`relative overflow-hidden ${wrapperClassName}`}>
      {lqip && !loaded && (
        <img src={lqip} alt="" aria-hidden
          style={{ objectPosition: style?.objectPosition || "center" }}
          className="absolute inset-0 w-full h-full object-cover scale-110 blur-xl" />
      )}
      <img
        {...imgProps}
        style={style}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        className={`${className} transition-opacity duration-700 ${loaded ? "opacity-100" : "opacity-0"}`}
      />
    </div>
  );
};
